import * as React from 'react'

import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { selectSkuItem, setInfoNumber } from '../../redux/reduces/skuSlice'
import * as classnames from "classnames"
import doLog from '../../common/log';
import { resetUrl } from '../../common/reset-image';
import { NumberPicker,Icon } from '@alifd/next';

const { useState, Fragment } = React;


export default function SkuItem(props: any) {
  const { 
    list = [], 
    id, 
    isLast, 
    index, 
    handleClick, 
    specsS, 
    i18n,
    type,
    // 是否可以下单
    startOrder,
    // 是否展示more
    showMore = false,
    skuInfoMap, 
    price = {},
    sampleInfo = {} } = props;
    const {maxQuantity = 0} = sampleInfo;
    const {batchNum = 1 } = price;

  if (!skuInfoMap) return null;

  const [isMore, setIsMore] = useState( showMore && (isLast ? list.length > 3 : list.length > 7))

  const dispatch = useAppDispatch()
  const skuInfo = useAppSelector(state => state.sku[type]);
  const skuInfoKeys = Object.keys(skuInfo.map).join('');
  const {quantity} = skuInfo;

  const getMax = (item: { inventoryCount: number; number: number}) => {
    const {inventoryCount, number} = item;
    if (type === 'sample') {
      const maxCount = Math.min(maxQuantity, inventoryCount);
      if (maxCount > quantity) {
        return maxCount;
      }
      else{
        return number || 0;
      }
    }
    return inventoryCount;
  }

  const renderSku = (item: { type: string; name: string; originImage: string; color: any; }, keyValue: string, isLast: any) => {
    const template = []
    if (item.type.toLocaleLowerCase() === 'image') {
      template.push(<img loading='lazy' onClick={e => {
        e.preventDefault();
        dispatch( selectSkuItem(item) );
      }} title={item.name} src={resetUrl(item.originImage, "100", 'xz')} />);
    } else if (item.type.toLocaleLowerCase() === 'text') {
      template.push(<span className='txt'>{item.name}</span>);
    } else {
      template.push(<span title={item.name} className="color" style={{
        backgroundColor: item.color
      }}/>);
    }
    // 最后补充文案说明/价格/数量选择
    if ( isLast && startOrder) {
        let lastKeyValue = specsS.slice( 0,-1 );
        lastKeyValue.push( keyValue );
        lastKeyValue = `${lastKeyValue.join( ";" )};`
        if ( item.type !== 'TEXT' ) {
            template.push( <span className="txt">{item.name}</span> );
        }

        if (skuInfoMap[lastKeyValue]) {
          const {formatPromotionPrice, formatPrice, price}  = skuInfoMap[lastKeyValue];
          template.push( <span className="price">{formatPromotionPrice || formatPrice || skuInfo.formatPrice || price }</span> );
          if (startOrder) {
            template.push( <NumberPicker min={0} max={getMax(skuInfoMap[lastKeyValue])} step={type === 'goods' ? batchNum : 1} onClick={() => {
              dispatch( selectSkuItem(item) )
            }} onChange={n => {
              if (type === "sample") {
                doLog('/sc.details.sampleSkuNumberClick');
              }else{
                doLog('/sc.details.wsSkuNumberClick');
              }
              dispatch( selectSkuItem(item) )
              dispatch(setInfoNumber({
                type,
                keyword: lastKeyValue,
                // 批量采购
                number: n
              }))
            }} value={skuInfoMap[lastKeyValue].number || 0} onBlur={(arg) => {
              try {
                const _val = parseInt(arg.target.value);
                if (type === 'goods' && batchNum > 1 && _val%batchNum > 0) {
                  dispatch(setInfoNumber({
                    type,
                    keyword: lastKeyValue,
                    // 批量采购
                    number: _val - _val % batchNum
                  }))
                }
              } catch (error) {
                console.warn(error);
              }
            }} type="inline" /> );
          }
        }
        // 无价格disable
        else{
          template.push( <span className="price">&nbsp;</span>)
          template.push(<NumberPicker value={0}  type="inline" disabled></NumberPicker>)
        }
    }
    return template;
  };

  const renderItem = (value: any, i: React.Key) => {
    const keys = specsS.slice(0, index);
    const keyValue = `${id}:${value.id}`;
    keys.push(keyValue);
    
    const isOption = skuInfoKeys.indexOf(keys.join(';')) > -1; // 当前规格是否可选
    const isActive = specsS.includes(keyValue); // 当前规格是否被选

    // 下单品可以设置起订量
    if (isLast && startOrder) {
      return <div className={classnames({
        "sku-option": true
      })}
      >
          {renderSku(value, keyValue, isLast)}
      </div>
    }

    return <a
      key={i}
      href="#"
      className={classnames({
        "sku-option": isOption,
        "sku-actived": isActive,
        "sku-disabled": !isOption,
      })}
      onClick={(e) => {
        e.preventDefault();
        if (!isOption) return false;
        // 下单无法取消
        if (startOrder && isActive) return false;
  
        // 更新主图
        if (type === "sample") {
          doLog('/sc.details.sampleSkuClick');
        }else{
          doLog('/sc.details.wsSkuClick');
        }
        dispatch( selectSkuItem(value) )
        handleClick(isOption, keyValue, index)
      }}
    >
      {renderSku(value, keyValue, isLast)}
    </a>
  }

  const renderShowLink = () => {
    if (isMore) {
      return <a href="#" className='view-more' onClick={e => {
        e.preventDefault();
        setIsMore(false);
      }}>{i18n["mainAction.showAllSku"].replace('{0}', list.length)}<Icon size="xxs" type="arrow-down" /></a>
    }
  }

  /**
   * 一行最多展示7
   * 一列最多展示3
   */
  const renderMore = () => {
    if (isMore) {
      if (isLast && startOrder) {
        return list.slice(0, 3).map((value: any, i: any) => renderItem(value, i))
      }else{
        return list.slice(0, 7).map((value: any, i: any) => renderItem(value, i))
      }
    }
    return list.map((value: any, i: any) => renderItem(value, i));
  }
  

  return <Fragment>
    <div className={classnames({
      "item-limt": startOrder ? isMore && !isLast : isMore,
      "item-last": startOrder && isLast,
      "item-size": true,
    })
    }>
      {renderMore()}
      {startOrder && isLast && <div className="sku-option">{renderShowLink()}</div> }
    </div>
    {(!isLast || !startOrder) && renderShowLink()}
  </Fragment>
}